import { differenceInWeeks, isValid, isFuture } from 'date-fns';

export const isWithinLast14Days = (timestamp: string | null | undefined): boolean => {
	if (!timestamp || timestamp.trim() === '') {
		return false;
	}

	const timestampDate = new Date(timestamp);

	if (!isValid(timestampDate)) {
		return false;
	}

	const now = new Date();

	// If the date is in the future, check if it's within 2 weeks from now
	if (isFuture(timestampDate)) {
		return differenceInWeeks(timestampDate, now) < 2;
	}

	// If the date is in the past, check if it's within 2 weeks ago
	return differenceInWeeks(now, timestampDate) < 2;
};
